export default "__VITE_ASSET__$cbg24UB__"